<template>
  <BCard>
    <div class="text-black text-[20px] mb-2 font-[600] d-flex align-items-center">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt="Komerce"
        class="cursor-pointer mx-1"
        @click="$router.back()"
      >
      Detail Document Request Collaborator
    </div>
    <div class="border rounded mt-3 px-1 px-lg-4 py-2">
      <div class="d-flex justify-content-between">
        <h5 class="text-black">
          Detail Data
        </h5>
        <div
          :class="getStatusClass(dataDetail.badge.toLowerCase())"
          class="rounded-pill text-center py-[5px] px-[10px] w-fit text-sm capitalize"
        >
          {{ dataDetail.badge || '-' }}
        </div>
      </div>
      <div class="d-flex mt-1">
        <span class="col-3 px-0">Full Name/Company</span>
        <span class="col">: {{ dataDetail.name || '-' }}</span>
      </div>
      <div class="d-flex mt-1">
        <span class="col-3 px-0">Email</span>
        <span class="col">: {{ dataDetail.email || '-' }}</span>
      </div>
      <div class="d-flex mt-1">
        <span class="col-3 px-0">Phone Number</span>
        <span class="col">: {{ dataDetail.contact || '-' }}</span>
      </div>
      <div class="d-flex mt-1 align-items-start">
        <span class="col-3 px-0">Address</span>
        <span class="col d-flex">
          <span class="mr-[5px]">:</span>
          <span>
            {{ dataDetail.address || '-' }}
          </span>
        </span>
      </div>
      <div class="d-flex mt-1">
        <span class="col-3 px-0">Document</span>
        <span class="col d-flex">
          <span class="mr-[5px]">:</span>
          <div class="d-flex gap-5 col px-0 flex-wrap">
            <b-dropdown
              variant="flat-dark"
              size="sm"
              class="m-0 p-0 bg-[#F8F8F8]"
              toggle-class="d-flex border rounded px-1 align-items-center justify-content-between h-[30px] gap-2 p-0"
              menu-class="shadow-sm border-0 w-[180px] p-2"
              no-caret
            >
              <template #button-content>
                <img
                  v-if="dataDetail.sla_overall_status"
                  :src="statusIcon(dataDetail.sla_overall_status)"
                  alt="status"
                  class="max-w-[18px] mr-1"
                >
                <span class="text-dark font-medium text-[14px]">SLA</span>
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg"
                  width="12px"
                  alt="arrow"
                >
              </template>
              <div class="d-flex flex-column gap-2 p-0">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">SLA Shipping</span>
                  <img
                    v-if="dataDetail.sla_shipping_status"
                    :src="statusIcon(dataDetail.sla_shipping_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">SLA Payment</span>
                  <img
                    v-if="dataDetail.sla_payment_status"
                    :src="statusIcon(dataDetail.sla_payment_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">SLA QRISLY</span>
                  <img
                    v-if="dataDetail.sla_qrisly_status"
                    :src="statusIcon(dataDetail.sla_qrisly_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
              </div>
            </b-dropdown>

            <b-dropdown
              variant="flat-dark"
              size="sm"
              class="m-0 p-0 bg-[#F8F8F8]"
              toggle-class="d-flex border rounded px-1 align-items-center justify-content-between h-[30px] gap-2 p-0"
              menu-class="shadow-sm border-0 w-[180px] p-2"
              no-caret
            >
              <template #button-content>
                <img
                  v-if="dataDetail.ca_overall_status"
                  :src="statusIcon(dataDetail.ca_overall_status)"
                  alt="status"
                  class="max-w-[18px] mr-1"
                >
                <span class="text-dark font-medium text-[14px]">CA</span>
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg"
                  width="12px"
                  alt="arrow"
                >
              </template>
              <div class="d-flex flex-column gap-2 p-0">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">CA Shipping</span>
                  <img
                    v-if="dataDetail.ca_shipping_status"
                    :src="statusIcon(dataDetail.ca_shipping_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">CA Payment</span>
                  <img
                    v-if="dataDetail.ca_payment_status"
                    :src="statusIcon(dataDetail.ca_payment_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
              </div>
            </b-dropdown>

            <b-dropdown
              variant="flat-dark"
              size="sm"
              class="m-0 p-0 bg-[#F8F8F8]"
              toggle-class="d-flex border rounded px-1 align-items-center justify-content-between h-[30px] gap-2 p-0"
              menu-class="shadow-sm border-0 w-[180px] p-2"
              no-caret
            >
              <template #button-content>
                <img
                  v-if="dataDetail.uat_overall_status"
                  :src="statusIcon(dataDetail.uat_overall_status)"
                  alt="status"
                  class="max-w-[18px] mr-1"
                >
                <span class="text-dark font-medium text-[14px]">UAT</span>
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg"
                  width="12px"
                  alt="arrow"
                >
              </template>
              <div class="d-flex flex-column gap-2 p-0">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">UAT Shipping</span>
                  <img
                    v-if="dataDetail.uat_shipping_status"
                    :src="statusIcon(dataDetail.uat_shipping_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="text-dark text-[14px]">UAT Payment</span>
                  <img
                    v-if="dataDetail.uat_payment_status"
                    :src="statusIcon(dataDetail.uat_payment_status)"
                    alt="status"
                    width="20px"
                  >
                </div>
              </div>
            </b-dropdown>
          </div>
        </span>
      </div>
    </div>
    <div class="mt-3 d-flex flex-column flex-md-row gap-5">
      <b-button
        v-for="(button, index) in buttonTabs"
        :key="index"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="tabPosition === index + 1 ? 'primary' : 'outline-secondary'"
        size="md"
        pill
        @click="switchTab(button.tabIndex)"
      >
        {{ button.label }}
      </b-button>
    </div>

    <b-tabs
      v-if="tabPosition === 1"
      content-class="mt-2"
      class="mt-2"
      lazy
    >
      <b-tab
        v-if="dataDetail.sla_shipping_status >= 4"
        title="SLA Shipping"
        active
      >
        <SLATab
          :get-detail="getDetail"
        />
      </b-tab>
      <b-tab
        v-if="dataDetail.sla_payment_status >= 4"
        title="SLA Payment"
      >
        <SLAPayment
          :get-detail="getDetail"
        />
      </b-tab>
      <b-tab
        v-if="dataDetail.sla_qrisly_status >= 4"
        title="SLA QRISLY"
      >
        <SLAQrisly
          :get-detail="getDetail"
        />
      </b-tab>
    </b-tabs>

    <b-tabs
      v-if="tabPosition === 2"
      content-class="mt-2"
      class="mt-2"
      lazy
    >
      <b-tab
        v-if="dataDetail.ca_shipping_status >= 4"
        title="CA Shipping"
        active
      >
        <CATab
          :get-detail="getDetail"
          :service-type="'shipping_delivery'"
        />
      </b-tab>
      <b-tab
        v-if="dataDetail.ca_payment_status >= 4"
        title="CA Payment"
      >
        <CATab
          :get-detail="getDetail"
          :service-type="'payment_service'"
        />
      </b-tab>
    </b-tabs>

    <b-tabs
      v-if="tabPosition === 3"
      content-class="mt-2"
      class="mt-2"
      lazy
    >
      <b-tab
        v-if="dataDetail.uat_shipping_status >= 4"
        title="UAT Shipping"
        active
      >
        <UATTab
          :get-detail="getDetail"
          :service-type="'shipping_delivery'"
        />
      </b-tab>
      <b-tab
        v-if="dataDetail.uat_payment_status >= 4"
        title="UAT Payment"
      >
        <UATPayment
          :get-detail="getDetail"
          :service-type="'payment_service'"
        />
      </b-tab>
    </b-tabs>
  </BCard>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { openApiAxiosIns, collaboratorAxiosIns } from '@/libs/axios'
import SLATab from '../components/SLATab.vue'
import CATab from '../components/CATab.vue'
import UATTab from '../components/UATTab.vue'
import UATPayment from '../components/UATPayment.vue'
import SLAPayment from '../components/SLAPayment.vue'
import SLAQrisly from '../components/SLAQrisly.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    SLATab,
    CATab,
    UATTab,
    UATPayment,
    SLAPayment,
    SLAQrisly,
  },
  data() {
    return {
      loading: false,
      tabPosition: 1,
      buttonTabs: [
        {
          label: 'Service Level Agreement',
          tabIndex: 1,
        },
        {
          label: 'Collaboration Agreement',
          tabIndex: 2,
        },
        {
          label: 'User Acceptance Test',
          tabIndex: 3,
        },
      ],
      userId: null,
      dataDetail: [],
    }
  },
  computed: {
    submitted() {
      if (this.dataDetail.document_sla_status === 6 || this.dataDetail.document_ca_status === 6 || this.dataDetail.uat_status === 6) {
        return 'rejected'
      }
      if (this.dataDetail.document_sla_status === 5 && this.dataDetail.document_ca_status === 5 && this.dataDetail.uat_status === 5) {
        return 'approved'
      }
      if (this.dataDetail.document_sla_status >= 4 || this.dataDetail.document_ca_status >= 4 || this.dataDetail.uat_status >= 4) {
        return 'submitted'
      }
      return ''
    },
    imgStatus() {
      if (this.dataDetail.document_sla_status === 6 || this.dataDetail.document_ca_status === 6 || this.dataDetail.uat_status === 6) {
        return 'https://storage.googleapis.com/komerce/assets/svg/danger-information-circle!.svg'
      }
      if (this.dataDetail.document_sla_status === 5 && this.dataDetail.document_ca_status === 5 && this.dataDetail.uat_status === 5) {
        return 'https://storage.googleapis.com/komerce/assets/svg/tick-circle.svg'
      }
      if (this.dataDetail.document_sla_status === 4 || this.dataDetail.document_ca_status === 4 || this.dataDetail.uat_status === 4) {
        return 'https://storage.googleapis.com/komerce/assets/email/info-circle!.png'
      }
      if (this.dataDetail.document_sla_status <= 3 || this.dataDetail.document_ca_status <= 3 || this.dataDetail.uat_status <= 3) {
        return 'https://storage.googleapis.com/komerce/assets/email/info-circle!.png'
      }
      return ''
    },
  },
  mounted() {
    const { id } = this.$router.history.current.params
    this.userId = id
    this.getDetail()
  },
  methods: {
    switchTab(v) {
      this.tabPosition = v
    },
    async getDetail() {
      this.loading = true

      const url = `/user/api/v1/admin/document-request/${this.userId}`
      await openApiAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.dataDetail = data
        })
        .catch(() => {
          this.loading = false
        })
    },
    viewHistory() {
      this.$router.push({ path: `/openapi/user-tracker/detail/history/${this.userId}` })
    },
    statusIcon(v) {
      if (v <= 3) return 'https://storage.googleapis.com/komerce/icon/circle-minus-gray.svg'
      if (v === 4) return 'https://storage.googleapis.com/komerce/assets/icons/minus-cirlce.svg'
      if (v <= 3) return 'https://storage.googleapis.com/komerce/icon/circle-minus-gray.svg'
      if (v === 4) return 'https://storage.googleapis.com/komerce/assets/icons/minus-cirlce.svg'
      if (v === 5) return 'https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg'
      if (v === 6) return 'https://storage.googleapis.com/komerce/assets/LP-Komads/Symbol%20close.svg'
      return ''
    },
    getStatusClass(v) {
      if (v === 'active') return 'approved'
      if (v === 'non active') return 'rejected'
      if (v === 'need revision') return 'rejected'
      if (v === 'non activated') return 'rejected'
      if (v === 'not started') return 'not-started'
      if (v === 'submitted') return 'submitted'
      if (v === 'approved') return 'approved'
      if (v === 'rejected') return 'rejected'
      return 'not-started'
    },
  },
}
</script>
<style scoped>
.submitted {
  background-color: #fffbe6;
  border: 1px solid #faad15;
  color: #faad15;
}
.approved {
  background-color: #eaffe6;
  border: 1px solid #32a46e;
  color: #32a46e;
}
.rejected {
  background-color: #ffe6e6;
  border: 1px solid #d22120;
  color: #d22120;
}
.not-started {
  background-color: #E2E2E2;
  color: #828282;
  border: 1px solid #828282;
}
</style>
